import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/check.svg";
var CheckSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  CheckSolid_default as default
};
